import Vue from 'vue';
import { i18n } from '../plugins/i18n-setup';

const _ = require('lodash');

// export default function VueInstance(el, vueObj, initialData) {
//   let tmp = _.cloneDeep(vueObj);
//
//   if (initialData) {
//     const mergeTmp = _.merge(tmp, initialData);
//     tmp = mergeTmp;
//   }
//
//   tmp.el = el;
//   return new Vue(tmp);
// }
export default function VueFactory(component, options, data, props = {}) {
  const opts = _.merge({}, options, { data() { return _.merge({}, options.data, data); } });
  return new Vue(_.merge({
    render: (h) => h(component, {
      props,
    }),
    i18n,
  }, opts));
}
